import { VTable } from 'roosterjs-editor-dom';
import { TableFormat } from 'roosterjs-editor-types';
import { callEditorApi } from './callEditorApi';

export const getTableFormat = (editorId: string): TableFormat | undefined => {
    const table = getElementAtCursor(editorId, 'TABLE') as HTMLTableElement;
    if (!table) {
        return undefined;
    }
    const vTable = new VTable(table);
    return vTable.formatInfo;
};

const getElementAtCursor = (editorId: string, selector: string): HTMLElement | undefined => {
    return callEditorApi(editorId, 'getElementAtCursor', selector);
};
